import adminTable from '@store/adminTable/reducers';

import { exams } from '@Modules/Exams/configs/constants';

export default adminTable(exams);
